const DeleteReasonDialog = ({ open, onClose, onConfirm, saving, reasonDescription }) => {
    if (!open) return null;

    return (
        <div className="pp-dialog-backdrop" onClick={onClose}>
            <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="pp-dialog__header">
                    <h3 className="pp-dialog__title">Delete Reason</h3>
                    <button className="dp-drawer__close" onClick={onClose}>
                        <i className="fe fe-x" />
                    </button>
                </div>
                <div className="pp-dialog__body">
                    <p className="pp-dialog__text">
                        Are you sure you wish to delete reason {reasonDescription}?
                    </p>
                </div>
                <div className="pp-dialog__footer">
                    <button className="dp-btn dp-btn--cancel" onClick={onClose}>
                        No
                    </button>
                    <button
                        className="dp-btn dp-btn--danger"
                        disabled={saving}
                        onClick={onConfirm}
                    >
                        {saving ? 'Deleting...' : 'Yes'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteReasonDialog;
